module.exports = __webpack_public_path__ + "img/stamp-error.666c9b7d.svg";